module.exports = __webpack_public_path__ + "img/bs-5.c5dfbd6f.jpg";